// =====================================
//
//   搜尋 相關功能 Service
//   Author: Wayne
//   createtime: 2016 / 08 / 02
//   updatetime: 2016 / 08 / 02
//
// =====================================
window.InifECShared.factory("SearchService", ['$q', '$http', function($q, $http) {

    var factory = {};

    // --------------------------------
    // 取得產品搜尋數量
    // --------------------------------
    var getSearchCount = function(keyword) {

        var params = {
            op: "getSearchCount",
            keyword: keyword,
        };

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/SearchAction.do",
            method: "GET",
            params: params,
            withCredentials: true
        }).success(function(data){
            if(data.error){
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function (data, status, headers, config){
            defer.reject(data);
            console.error("[InifEC Error] : SearchService.getProductInfo request error.");
            console.error("status : " + status);
        });

        return defer.promise;

    };

    /*==========================
        Members
    ==========================*/
    // 取得搜尋結果數量
    factory.getSearchCount = getSearchCount;

    /*==========================
        Methods
    ==========================*/


    return factory;
}]);